
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css'
import RoutesPage from './components/routesPage/RoutesPage'

function App() {
  return (
    <div className="App">
      <RoutesPage />
    </div>
  );
}

export default App;
